module.exports = __webpack_public_path__ + "img/brainEmotion1.0745d3d7.png";